import React from 'react';
import { ToggleButton, ToggleButtonGroup, Tooltip } from '@mui/material';
import ViewAgendaOutlinedIcon from '@mui/icons-material/ViewAgendaOutlined';
import ViewHeadlineIcon from '@mui/icons-material/ViewHeadline';
import TableChartOutlinedIcon from '@mui/icons-material/TableChartOutlined';
import { TableViewMode } from './responsiveTable.types';

interface TableViewSwitcherProps {
    mode: TableViewMode;
    onChange: (mode: TableViewMode) => void;
}

/**
 * The three-way view control.
 *
 * Rendered only by pages that can actually honour all three modes — a page still on the Tier-0
 * scroll wrapper must not show this, because flipping it would do nothing.
 */
const TableViewSwitcher = ({ mode, onChange }: TableViewSwitcherProps) => (
    <ToggleButtonGroup
        size="small"
        exclusive
        value={mode}
        onChange={(_, next: TableViewMode | null) => next && onChange(next)}
        aria-label="Table view mode"
        data-help="common.tableView.switcher"
    >
        <Tooltip title="Cards">
            <ToggleButton value="cards" data-help="common.tableView.cards" aria-label="Cards view"><ViewAgendaOutlinedIcon fontSize="small" /></ToggleButton>
        </Tooltip>
        <Tooltip title="Compact">
            <ToggleButton value="compact" data-help="common.tableView.compact" aria-label="Compact view"><ViewHeadlineIcon fontSize="small" /></ToggleButton>
        </Tooltip>
        <Tooltip title="Full table">
            <ToggleButton value="table" data-help="common.tableView.table" aria-label="Table view"><TableChartOutlinedIcon fontSize="small" /></ToggleButton>
        </Tooltip>
    </ToggleButtonGroup>
);

export default TableViewSwitcher;
